import React from "react";
import { useState } from "react";
import { FiPlusCircle } from "react-icons/fi";
import PostCard from "./PostCard";
import GroupActivityButton from "./GroupActivityButton";
import NewGroupPostAdd from "../NewGroupPostAdd";
import AddPostModal from "../AddPostModal";
import { getGroupPostsService } from "../../../services/GroupService";

function PostSection({ posts, selectedGroup,getGroupPosts }) {
  const [modalShow, setModalShow] = useState(false);
  const [PostData, setPostData] = useState(posts);
  // const [vidImgShow, setVidImgShow] = useState(false);
  const [newComment, setNewComment] = useState(posts?.comments);
  console.log(selectedGroup)
  // const getGroupPosts = async () => {
  //   try {
  //     const response = await getGroupPostsService(selectedGroup._id);
  //     if (response) {
  //       // setNewComment(response.comments);
  //       setPostData(response);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  //   useEffect(() => {}, []);
  return (
    <>
      <div
        className="group_backwhite mt-4 p-4 flex-fill"
        style={{ backgroundColor: "rgba(227, 236, 237, 1)" }}
      >
        <div className="row justify-content-between py-3">
          {Object.keys(selectedGroup ? selectedGroup : {}).length > 0 ? (
            <div className="col-9">
              <h5 className="name">{selectedGroup?.groupName}</h5>
              <p style={{ fontSize: "0.9rem" }}>{selectedGroup?.description}</p>
            </div>
          ) : (
            <div className="col-6">
              <h5 className="name">Welcome to Dr Lisa Park</h5>
              <p style={{ fontSize: "0.9rem" }}>
                Your group members are waiting to connect with you
              </p>
            </div>
          )}

          <div className="col-3 text-end">
            <GroupActivityButton
              width="100%"
              borderRadius="8px"
              padding="5px 6px"
              backgroundColor="rgba(31, 126, 120, 1)"
              border="3px solid rgba(31, 126, 120, 1)"
              color="white"
              fontWeight=""
              onClick={() => setModalShow(true)}
            >
              {" "}
              <FiPlusCircle className="mb-1" size={"20px"} /> Create Post{" "}
            </GroupActivityButton>
          </div>
        </div>

        {/* Post Section */}

        { Object.keys(selectedGroup ? selectedGroup : {}).length > 0 && posts?.length > 0 ? (
          <>
            <div className="rounded-4   bg-white h-full">
              <div
                className="py-4 px-4 rounded-top-4 text-white"
                style={{ backgroundColor: "rgba(31, 126, 120, 1)" }}
              >
                <h4 className=" headFont ">Latest Post</h4>
              </div>
              {/* {posts?.map((dt, i) => {
                return ( */}
              <PostCard
                dt={posts}
                // comments={newComment}
                selectedGroup={selectedGroup}
                getGroupPosts={getGroupPosts}
              />
              {/* );
              })} */}
            </div>
          </>
        ) : (
           (
            <div className="rounded-4  bg-white h-full">
              <div
                className="py-4 px-4 rounded-top-4 text-white"
                style={{ backgroundColor: "rgba(31, 126, 120, 1)" }}
              >
                <h4 className=" headFont ">Latest Post</h4>
              </div>
              <div className="d-flex flex-column justify-content-center align-items-center p-5">
                <svg
                  width="219"
                  height="219"
                  viewBox="0 0 219 219"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M146 173.375H27.375V155.125H146V173.375ZM191.625 82.125H27.375V100.375H191.625V82.125ZM27.375 45.625V63.875H127.75V45.625H27.375ZM155.125 45.625V63.875H191.625V45.625H155.125ZM100.375 118.625V136.875H191.625V118.625H100.375ZM27.375 118.625V136.875H73V118.625H27.375Z"
                    fill="#1F7E78"
                  />
                </svg>
                <p className="resFont">
                  Add New Post by clicking the “Create Post” button or{" "}
                  <a
                    className="pointer text-primary"
                    onClick={() => setModalShow(true)}
                  >
                    click here
                  </a>
                </p>
              </div>
            </div>
          )
        )}
      </div>
      <AddPostModal
        gname={selectedGroup?.groupName}
        gid={selectedGroup?._id}
        show={modalShow}
        getGroupPosts={getGroupPosts}
        onHide={() => setModalShow(false)}
      />
    </>
  );
}

export default PostSection;
